import cuid from "cuid";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import Card from "shared/components/Card";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { PROCESS_CONFIG_TYPES } from "utils/constants";
import { bindInputProps } from "utils/helpers/input";

const AdditionalConfiguration = ({
  formRef,
  dirtyRef,
  setIsDirty,
  TABS,
  onSubmit,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.PROCESS);
  const FORM = t("FORM", { returnObjects: true });

  return (
    <Formik
      innerRef={(formik) => {
        formRef.current = formik;
      }}
      initialValues={{
        produit: "",
      }}
      onSubmit={async (values) => {
        const productConfig = values.produit
          ? [
              {
                id: cuid(),
                type: PROCESS_CONFIG_TYPES.PRODUCT,
                value: values.produit || "",
              },
            ]
          : [];

        await onSubmit({
          type: "",
          name: "",
          theme: null,
          description: "",
          skills: [],
          config: productConfig,
          attributionType: null,
          processStatuses: [],
          insurancePlans: [],
        });
        setIsDirty((prev) => ({ ...prev, [TABS.ADDITIONAL_CONFIG]: false }));
      }}
    >
      {({ values, dirty, ...formProps }) => {
        if (dirtyRef.current !== dirty) {
          dirtyRef.current = dirty;
          setIsDirty((prev) => ({ ...prev, [TABS.ADDITIONAL_CONFIG]: dirty }));
        }

        return (
          <Card
            type="simple"
            head={false}
            title={FORM.ADDITIONAL_CONFIG || "Configuration Additionnel"}
          >
            <div className="grid--3">
              <Input
                type="simple"
                placeholder={FORM.PRODUCT || "Produit"}
                label={FORM.PRODUCT || "Produit"}
                {...bindInputProps({
                  name: "produit",
                  values,
                  ...formProps,
                })}
              />
            </div>
          </Card>
        );
      }}
    </Formik>
  );
};

export default AdditionalConfiguration;
